import React, {useEffect} from 'react'
import {ChevronLeftIcon} from "@heroicons/react/24/solid";
import {Link} from "react-router-dom";

const ShowBlogPostStatus = ({
                                blogPost
                            }) => {
    const [initialStep, setInitialStep] = React.useState(true);
    const [showStatus, setShowStatus] = React.useState(true);


    useEffect(() => {
        setShowStatus(false);

        setTimeout(() => {
            setShowStatus(true);
        }, 1);
    }, [blogPost?.title]);

    return (
        <>
            {showStatus &&
                <>
                    <div className={'flex justify-start items-center w-full'}>
                        <div>
                            {blogPost?.status === 'Published' &&
                                <div className={`w-20 text-sm text-center px-1 button-green`}>{blogPost?.status}</div>
                            }

                            {blogPost?.status === 'New' && blogPost?.title !== '' &&
                                <div className={`w-20 text-sm text-center px-1 button-gray`}>{blogPost?.status}</div>
                            }

                            {blogPost?.status === 'Draft' &&
                                <div className={`w-20 text-sm text-center px-1 button-purple`}>{blogPost?.status}</div>
                            }

                            {blogPost?.status === 'Ready' &&
                                <div className={`w-20 text-sm text-center px-1 button-sky`}>{blogPost?.status}</div>
                            }

                            {(blogPost?.status === '' || !blogPost?.status || !blogPost.hasOwnProperty('status') || blogPost?.title === '') &&
                                <div className={`w-20 text-sm text-center px-1 button-red`}>No Title</div>
                            }
                        </div>

                        {blogPost?.hasOwnProperty('postGenerationStatus') && blogPost?.postGenerationStatus !== '' && blogPost?.postGenerationStatus !== null &&
                            <div
                                className={`text-sm text-center px-1 button-sky-outline ml-2`}>{blogPost?.postGenerationStatus}</div>
                        }
                    </div>
                </>
            }
        </>
    )
}

export default ShowBlogPostStatus
